import { Breadcrumbs, Stack } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";

import { Link } from "react-router-dom";
import { COLORS, output } from "../settings/themeSettings";




const DossierPageBase = (props) => {

    let location = useLocation();
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const navigateTo = useNavigate();
    


    const handleClick = useCallback((e, path) => {
        e.preventDefault();
        output(location.pathname.indexOf(path));
        if (location.pathname.indexOf(path) !== 10) {
            output(location.pathname.split(path)[0]);
            let currentPath = location.pathname.split(path)[0];
            if (isNaN(path)) {
                navigateTo(currentPath);
            } else {
                navigateTo(`${currentPath}${path}`);
            }
        } else {
            navigateTo(`/dossiers/${path}`);
        }
    }, [location.pathname, navigateTo]);

    useEffect(() => {

        output(location);
        let url = 'dossiers';

        let links = location.pathname.split('/').map((path, idx) => {
            url = url + '/' + path;
            if (path !== 'dossiers' && path !== '') {
                return (
                    <Link
                        key={idx}
                        style={{ color: "#FFF", fontSize: '1em', fontWeight: 'bold', textDecoration: 'none' }}
                        onClick={(e) => handleClick(e, path)}
                    >
                        {path}
                    </Link>
                );
            }
            return null;
        }).filter(Boolean);

        setBreadcrumbs(links);

    }, [location, handleClick]);

    return <div className="dossier-base">
        <Stack spacing={2} direction="row" alignItems="center" 
        sx={{ height: 50, mt: 2, mb: 2, bgcolor: COLORS.secondary, color: '#FFF', borderRadius: '5px' }}>

            <Breadcrumbs separator=">" aria-label="breadcrumb" color="inherit">
                {breadcrumbs}
            </Breadcrumbs>
        </Stack>
        <Outlet />
    </div>
}


export default DossierPageBase;
